export default "__VITE_ASSET__013432e0__"